module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAATklEQVQ4jd2QMQ7AMAgDz1W+Rx4LD6RDFalrSCWk3oIYbLChGwG4e1bEc06NtZjZljgiALgql98cG+gZWeoApP4IAyBXkk30xQf9Bj/gBlMoChqokj8eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/RU.png
// module id = 1253
// module chunks = 0